<div id="drawer-wrapper">
  <div #contentWrapper id="drawer-content">
    <ion-router-outlet></ion-router-outlet>
  </div>

  <div id="drawer-handle">
    <ion-button size="small" fill="clear" expand="full" (click)="close()">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
    <ion-button size="small" fill="clear" expand="full" (click)="maximize()">
      <ion-icon slot="icon-only" name="open-outline"></ion-icon>
    </ion-button>
    <hr>
    <ion-button size="small" fill="clear" expand="full" (click)="expand()">
      <ion-icon slot="icon-only" name="arrow-forward"></ion-icon>
    </ion-button>
    <ion-button size="small" fill="clear" expand="full" (click)="shrink()">
      <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
    </ion-button>

    <ic-icon id="drag-indicator" [icon]="dragIcon"></ic-icon>
  </div>
</div>
